import { updatePassword } from "@aws-amplify/auth";
import { localStorageGetUserId } from "@/common/localStorageUtil";
import type { OperationInput } from "@/generated/graphql";
import { recordPasswordChangeLog } from "@/common/graphql/cognito";

const PASSWORD_CHANGE_DISPLAY_CATEGORY = "パスワード変更";
const PASSWORD_CHANGE_OPERATION = "パスワード変更";

type PasswordChangeLogStatus = "success" | "failure";

export const createLogInput = (
  status: PasswordChangeLogStatus,
  errorType = ""
): OperationInput => ({
  detail:
    status === "success"
      ? "パスワード変更に成功"
      : "パスワード変更に失敗",
  display_category: PASSWORD_CHANGE_DISPLAY_CATEGORY,
  operation: PASSWORD_CHANGE_OPERATION,
  note:
    status === "success"
      ? "change-password-success"
      : `change-password-failure${errorType ? `:${errorType}` : ""}`,
  user_id: localStorageGetUserId(),
});

/**
 * パスワード変更 API通信を扱う composable。
 * Amplify Auth の updatePassword を使用してパスワード変更を行う。
 */
export const usePasswordChangeApi = () => {
  /**
   * パスワードを変更する。
   * @param oldPassword 現在のパスワード
   * @param newPassword 新しいパスワード
   */
  async function changePassword(
    oldPassword: string,
    newPassword: string
  ): Promise<void> {
    await updatePassword({ oldPassword, newPassword });
  }

  /**
   * パスワード変更ログを送る。
   */
  async function logPasswordChange(
    status: PasswordChangeLogStatus,
    errorType = ""
  ): Promise<void> {
    await recordPasswordChangeLog(createLogInput(status, errorType));
  }

  return {
    changePassword,
    createLogInput,
    logPasswordChange,
  };
};
